const defaultLocale = "ru";

// Ссылка на документации по локализации и по методам работы с локалью находится в ридмишке в корне проекта.

// Определяет самый приоритетный поддерживаемый язык. Нужен для переводов.
export function getSupportedLocale() {
  const supportedCultures = ["ru", "en", "hy", "kk", "ky", "uz"];
  return (
    process.env.LOCALE ||
    (window.getSupportedCulture &&
      window.getSupportedCulture(supportedCultures)) ||
    defaultLocale
  );
}

// Определяет язык, выбранный в выпадашке смены языка. Нужен для логики.
export function getSelectedLocale() {
  return (
    process.env.LOCALE ||
    (window.getSelectedCulture && window.getSelectedCulture()) ||
    defaultLocale
  );
}

export function setLocale(nextLocale) {
  window.setCulture && window.setCulture(nextLocale);
}
